export default "__VITE_ASSET__54c3dc72__"